import { motion } from "framer-motion";
import EventPackageCard from "./EventPackageCard";

const WineEventsList = ({ events }) => {
	const container = {
		show: {
			transition: {
				staggerChildren: 0.1,
			},
		},
	};

	const item = {
		hidden: { opacity: 0, y: 100 },
		show: { opacity: 1, y: 0 },
	};

	return (
		<motion.div
			variants={container}
			initial="hidden"
			animate="show"
			className="flex items-center justify-center flex-wrap"
		>
			{events.map((event) => (
				<motion.div
					key={event.id}
					variants={item}
					className="w-full max-w-320 sm:w-1/3 p-12"
				>
					<EventPackageCard event={event} />
				</motion.div>
			))}
		</motion.div>
	);
};

export default WineEventsList;
